import withLazy from '../../hoc/with-lazy';
const EmotionsMetadataLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-emotion-metadata"*/ './emotions-metadata'),
    errorHandling: { type: 'HANDLE' },
});
export default EmotionsMetadataLazy;
//# sourceMappingURL=emotions-metadata-lazy.js.map